// main scss file
import '../scss/style.scss';
import '../scss/admin.scss';

import './script';


// WEBPACK FOOTER //
// ./assets/js/app.js